<template>
  <div class="video-container">
    <div class="video">
      <video
        ref="video"
        :poster="videoPoster"
        :src="videoUrl"
        controls="controls"
        preload="auto"
        class="video"
        >
      </video>
      <div v-show="showPlayIcon" class="play-icon icomoon-triangle" @click="handelPlayVideo" style></div>
    </div>
    <div v-if="videoDescription" class="vide-description">
      <p class="content">{{ videoDescription }}</p>
    </div>
  </div>
</template>

<script>
import { getFilePath } from '@/utils/qiniu'

export default {
  props: {
    value: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      showPlayIcon: true
    }
  },
  computed: {
    videoUrl () {
      if (this.value?.items?.length > 0) {
        return getFilePath(this.value.items[0].resource_key)
      }
      return ''
    },
    videoPoster () {
      if (this.value?.items?.length > 0) {
        return getFilePath(this.value.items[0].cover_resource_key)
      }
      return ''
    },
    videoDescription () {
      if (this.value?.items?.length > 0) {
        return this.value.items[0].description
      }
      return ''
    }
  },
  created () {
  },
  mounted () {
    this.$refs.video.addEventListener('play', () => {
      this.showPlayIcon = false
    })
    this.$refs.video.addEventListener('pause', () => {
      this.showPlayIcon = true
    })
  },
  methods: {
    handelPlayVideo () {
      this.$refs.video.play()
    }
  }
}
</script>

<style lang="scss" scoped>
.video-container {
  background-color: #eaeaea;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 42px 0;
  position: relative;

  .video {
    width: 490px;
    position: relative;

    .play-icon {
      position: absolute;
      cursor: pointer;
      top: 50%;
      left: 50%;
      width: 60px;
      height: 60px;
      margin-top: -30px;
      margin-left: -30px;
      border-radius: 50%;
      line-height: 60px;
      font-size: 30px;
      background-color: rgba(0, 0, 0, .5);
      color: #fff;
      padding-left: 18px;
      box-sizing: border-box;
    }
  }

  .vide-description {
    padding: 42px 44px 0 44px;
    text-align: center;

    .content {
      line-height: 30px;
      font-size: 15px;
      margin: 0;
    }
  }
}
</style>
